import { createContext } from 'react'
import noop from 'lib/function/noop'

type OfferDescriptionInteractionHandlers = {
  onDescriptionExpand: () => void
  onDescriptionImpression: () => void
}

const defaultHandlers: OfferDescriptionInteractionHandlers = {
  onDescriptionExpand: noop,
  onDescriptionImpression: noop,
}

const OfferDescriptionInteractionContext = createContext<OfferDescriptionInteractionHandlers>(defaultHandlers)

export default OfferDescriptionInteractionContext
